import { Script } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';

export interface SEO {
  _uid: string;
  title: string;
  plugin: string;
  og_image: string;
  og_title: string;
  description: string;
  twitter_image: string;
  twitter_title: string;
  og_description: string;
  twitter_description: string;
}

interface HeadProps {
  seo: SEO;
  canonicalTag?: string;
  canIndex: boolean;
  location: { pathname: string };
}

const Head: React.FC<HeadProps> = ({
  seo,
  canonicalTag = undefined,
  canIndex,
  location,
}) => {
  const url = process.env.GATSBY_WEBSITE_URL + location.pathname;

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{seo?.title || process.env.GATSBY_SITE_TITLE}</title>
      <meta name="viewport" content="width=device-width" />
      <meta name="description" content={seo?.description || ''} />
      <meta
        property="og:title"
        content={seo?.og_title || process.env.GATSBY_SITE_TITLE}
      />
      <meta property="og:site_name" content={process.env.GATSBY_SITE_TITLE} />
      <meta property="og:description" content={seo?.og_description || ''} />
      <meta property="og:image" content={seo?.og_image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en" />
      <meta name="twitter:title" content={`${seo?.twitter_title || ''}`} />
      <meta
        name="twitter:description"
        content={`${seo?.twitter_description || seo?.description}`}
      />
      <meta name="twitter:image" content={seo?.twitter_image} />
      <meta name="language" content={'English'} />
      {!canIndex && <meta name="robots" content="noindex" />}
      <link rel="canonical" href={canonicalTag || url} />
      <script src="/scripts/liveperson.js" type="text/javascript" />

      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />

      <script type="text/javascript">
        {`
          var kameleoonLoadingTimeout=1e3;if(window.kameleoonQueue=window.kameleoonQueue||[],window.kameleoonStartLoadTime=new Date().getTime(),!document.getElementById("kameleoonLoadingStyleSheet")&&!window.kameleoonDisplayPageTimeOut){var e=document.getElementsByTagName("script")[0],o="* { visibility: hidden !important; background-image: none !important; }",t=document.createElement("style");t.type="text/css",t.id="kameleoonLoadingStyleSheet",t.styleSheet?t.styleSheet.cssText=o:t.appendChild(document.createTextNode(o)),e.parentNode.insertBefore(t,e),window.kameleoonDisplayPage=function(e){e||(window.kameleoonTimeout=!0),t.parentNode&&t.parentNode.removeChild(t)},window.kameleoonDisplayPageTimeOut=window.setTimeout(window.kameleoonDisplayPage,kameleoonLoadingTimeout)}
      `}
      </script>

      <script
        type="text/javascript"
        src="//8fbqpxgfb6.kameleoon.io/kameleoon.js"
        async={true}
      ></script>
      <script type="text/javascript">
        {`
      window._vwo_code || (function() {
var account_id=911297,
version=2.1,
settings_tolerance=2000,
hide_element='body',
hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
/* DO NOT EDIT BELOW THIS LINE */
f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var i=this.getSettings(),n=d.createElement('script'),r=this;t=t||{};if(i){n.textContent=i;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var i=this.hide_element(),n=i?i+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=n;else t.appendChild(d.createTextNode(n));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var n=d.createElement('div');n.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;';n.setAttribute('id','_vis_opt_path_hides');n.classList.add('_vis_hide_layer');t.parentNode.insertBefore(n,t.nextSibling)}var o='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:o})}else{this.load(o+'&x=true')}}};w._vwo_code=code;code.init();})();`}
      </script>

      {/*-- 
        structured data stuff - for some reason our structured data 
        functional component will not render here, so we will need 
        to do it inline
      --*/}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          url: `${process.env.GATSBY_WEBSITE_URL}`,
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${process.env.GATSBY_WEBSITE_URL}/?s={search_term_string}`,
            },
            'query-input': 'required name=search_term_string',
          },
        })}
      </script>
    </Helmet>
  );
};

export default Head;
